/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleContextCourseId } from './moduleContextCourseId';
import type { ModuleContextCurrentTaskId } from './moduleContextCurrentTaskId';

/**
 * Context for a specific module
 */
export interface ModuleContext {
  moduleId: string;
  courseId?: ModuleContextCourseId;
  currentTaskId?: ModuleContextCurrentTaskId;
}
